var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.442,
    height: 20.441,
    viewBox: "0 0 36.442 36.441",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8306",
    "data-name": "Group 8306",
    transform: "translate(15890.93 19315.743)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16079",
    "data-name": "Path 16079",
    d: "M1172.3,45.018a18.222,18.222,0,1,0-18.149-18.275A18.23,18.23,0,0,0,1172.3,45.018",
    transform: "translate(-17045.084 -19324.32)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16080",
    "data-name": "Path 16080",
    d: "M1172.3,45.018A18.222,18.222,0,1,1,1190.6,26.889,18.229,18.229,0,0,1,1172.3,45.018m.72-31.143c0,1.1,0,2.126,0,3.15,0,4.853.015,9.705-.017,14.558a3.693,3.693,0,0,1-3.495,3.7,3.761,3.761,0,0,1-3.95-3.23,3.709,3.709,0,0,1,3.034-4.163,9.928,9.928,0,0,1,1.8-.016c0-1.36.024-2.686-.029-4.009-.007-.171-.4-.46-.625-.468a7.848,7.848,0,0,0-7.487,3.987,7.764,7.764,0,0,0-.078,8.206,8.092,8.092,0,0,0,9.18,3.89,8.2,8.2,0,0,0,6.1-7.978c.024-2.657,0-5.313.008-7.97,0-.283.023-.566.036-.852a29.554,29.554,0,0,0,2.972,1.287,28.549,28.549,0,0,0,3.126.626V20.1c-3.722-.435-5.782-2.509-6.2-6.226Z",
    transform: "translate(-17045.084 -19324.32)",
    fill: "#5aa2fb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.17aa64c5fdbb0102abc1ab55b66376a8.svg";
export { ForwardRef as ReactComponent };